import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { GlobalModel } from "../common/utils";
import { CmsLinks } from "./global.types";

interface GlobalState extends GlobalModel {
  otpExpiryTime: number | null;
  sessionActive: boolean | null;
  cmsLinks: CmsLinks;
  sidebarCollapsed: boolean;
}

const initialState: GlobalState = {
  loading: false,
  otpExpiryTime: null,
  sessionActive: false,
  cmsLinks: {
    privacy_policy: "",
    terms_of_use: "",
    your_privacy_choices: "",
  },
  sidebarCollapsed:
    typeof window !== "undefined"
      ? sessionStorage.getItem("sidebarCollapsed") === "true"
      : false,
};

const globalSlice = createSlice({
  name: "globalSlice",
  initialState,
  reducers: {
    setLoading: (state: GlobalModel, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setOtpExpiryTime: (
      state: GlobalState,
      action: PayloadAction<number | null>,
    ) => {
      state.otpExpiryTime = action.payload;
    },
    setSessionActive: (state: any, action: PayloadAction<boolean | any>) => {
      state.sessionActive = action.payload;
    },
    setCmsLinks: (state, action: PayloadAction<CmsLinks>) => {
      state.cmsLinks = action.payload;
    },
    toggleSidebar: (state) => {
      state.sidebarCollapsed = !state.sidebarCollapsed;
      if (typeof window !== "undefined") {
        sessionStorage.setItem(
          "sidebarCollapsed",
          String(state.sidebarCollapsed),
        );
      }
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setLoading,
  setOtpExpiryTime,
  setSessionActive,
  setCmsLinks,
  toggleSidebar,
} = globalSlice.actions;

export default globalSlice.reducer;
